"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.identify = exports.track = exports.pushGtmDatalayer = exports.pushGtmEvent = void 0;
const pushGtmEvent = (eventName, args) => {
    var _a;
    try {
        ;
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({
            event: eventName,
            ...args,
        });
    }
    catch (err) {
        console.error(err);
    }
};
exports.pushGtmEvent = pushGtmEvent;
const pushGtmDatalayer = (args) => {
    var _a;
    try {
        ;
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({
            ...args,
        });
    }
    catch (err) {
        console.error(err);
    }
};
exports.pushGtmDatalayer = pushGtmDatalayer;
const track = (event, body) => {
    var _a;
    try {
        ;
        (_a = window.analytics) === null || _a === void 0 ? void 0 : _a.track(event, body);
    }
    catch (err) {
        console.error(err);
    }
};
exports.track = track;
const identify = (data) => {
    var _a;
    try {
        ;
        (_a = window.analytics) === null || _a === void 0 ? void 0 : _a.identify(data);
    }
    catch (err) {
        console.error(err);
    }
};
exports.identify = identify;
//# sourceMappingURL=gtm.js.map